export interface IForm {
    usuario: string;
    email: string;
}

export const initIForm: IForm = {
    email: '',
    usuario: ''
}